import { PageUrlCheckRender } from 'components/page-url-check-render';
import type { PropsWithChildren } from 'react';

export const CreditLineRouteWithPageUrlCheck = ({
  children,
}: PropsWithChildren) => {
  return <PageUrlCheckRender>{children}</PageUrlCheckRender>;
};
